<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'selected.requests.text' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
<ul role="list" class="divide-y divide-gray-200 overflow-y-auto zuper-scrollbar data-picker-list-content-height"
    *ngIf="requests.length">
    <li class="request-data-picker-list-ele" *ngFor="let request of requests">
        <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5"
            [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
            (click)="selectOption === 'readOnly' ? viewRequestDetails($event, request.request_uid) : null">
            <a class="-m-1 block flex-1 p-1">
                <div class="relative flex min-w-0 flex-1 items-center">
                    <mat-checkbox (change)="selectRequest($event, request)" *ngIf="selectOption === 'multiSelect'"
                        [checked]="isSelectedRequest(request)" color="primary" disableRipple="true"
                        matTooltipPosition="below">
                        <div class="ml-4 truncate">
                            <ng-container *ngTemplateOutlet="requestsContent"></ng-container>
                        </div>
                    </mat-checkbox>
                    <mat-radio-button (change)="selectRequest($event, request)" *ngIf="selectOption === 'select'"
                        [checked]="isSelectedRequest(request)" color="primary" disableRipple="true"
                        matTooltipPosition="below">
                        <div class="ml-4 truncate">
                            <ng-container *ngTemplateOutlet="requestsContent"></ng-container>
                        </div>
                    </mat-radio-button>
                    <ng-container *ngIf="selectOption === 'readOnly'">
                        <div class="truncate w-full">
                            <ng-container *ngTemplateOutlet="requestsContent"></ng-container>
                        </div>
                    </ng-container>
                    <ng-template #requestsContent>
                        <div class="flex items-center justify-between">
                            <div class="w-full">
                                <div class="flex flex-row space-x-2 w-11/12">
                                    <p class="truncate text-lg font-medium text-gray-900 cursor-pointer">
                                        {{request.request_id ? (request.request_id + ' - '): ''}}{{request.request_title}}
                                    </p>
                                </div>
                                <div class="flex flex-row space-x-2 mt-1" *ngIf="request?.request_service?.service_name">
                                    <p class="truncate text-base text-gray-500" *ngIf="request?.request_service?.service_name">
                                        {{request?.request_service?.service_name}}
                                    </p>
                                </div>
                            </div>
                            <div class="ml-auto mr-4">
                                <badge *ngIf="request?.request_status && request?.request_status?.status_name"
                                    [options]="getRequestStatusOptions(request?.request_status)"></badge>
                            </div>
                        </div>
                    </ng-template>
                    <div class="flex ml-auto items-center h-full">
                        <button mat-icon-button class="cursor-pointer" matTooltip="{{ updateArrowTooltipText(request.request_uid) | translate }}"
                            matTooltipPosition="above" *ngIf="!showSpinLoading(request.request_uid)" [ngClass]="rotateArrowIcon(request.request_uid)"
                            (click)="viewRequestDetails($event, request.request_uid)">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true" data-mat-icon-type="svg"
                                data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down" width="24"
                                    height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none">
                                    </path>
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </mat-icon>
                        </button>
                        <div class="py-2.5 h-10 w-12" *ngIf="showSpinLoading(request.request_uid)">
                            <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px">
                            </mat-spinner>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <div class="p-4 bg-gray-100"
            *ngIf="('request_details_' + request.request_uid === requestEleId) && requestDetails && !isSpinLoading">
            <div class="bg-card rounded relative">
                <a target="_blank" class="hidden" #requestViewFullDetails href="{{viewRequestFullDetails(request.request_uid)}}"></a>
                <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="requestViewFullDetails.click($event)"
                    matTooltip="{{'text.view_details.new_tab' | translate}}" matTooltipPosition="left">
                    <button mat-icon-button>
                        <mat-icon class="text-xl">open_in_new</mat-icon>
                    </button>
                </span>
                <div class="text-base">
                    <div class="px-2 truncate grid grid-cols-2">
                        <div *ngIf="requestDetails.customer?.customer_first_name"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer request-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'customer' | translate}}</p>
                            <p class="mt-1 text-gray-900 truncate"
                                *ngIf="requestDetails.customer?.is_deleted === true || !utilityService.hasModuleAccess('CUSTOMER')">
                                {{requestDetails.customer.customer_first_name}}
                                {{requestDetails.customer.customer_last_name ?? ''}}</p>
                            <p class="mt-1 truncate">
                                <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                    [routerLink]="utilityService.getLink('CUSTOMER', requestDetails.customer.customer_uid)"
                                    *ngIf="!requestDetails.customer?.is_deleted && utilityService.hasModuleAccess('CUSTOMER')">
                                    {{requestDetails.customer.customer_first_name}}
                                    {{requestDetails.customer.customer_last_name ?? ''}}</a></p>
                        </div>
                        <div *ngIf="requestDetails.organization"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer request-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.organization_name' | translate}}</p>
                            <p class="mt-1 text-gray-900 truncate"
                                *ngIf="requestDetails.organization?.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION')">
                                {{requestDetails.organization?.organization_name}}</p>
                            <p class="mt-1 truncate">
                                <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                    [routerLink]="utilityService.getLink('ORGANIZATION', requestDetails.organization.organization_uid)"
                                    *ngIf="!requestDetails.organization?.is_deleted && utilityService.hasModuleAccess('ORGANIZATION')">
                                    {{requestDetails.organization?.organization_name}}</a>
                            </p>
                        </div>
                        <div *ngIf="requestDetails.property"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer request-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.property' | translate}}</p>
                            <p class="mt-1 text-gray-900 truncate"
                                *ngIf="requestDetails.property?.is_deleted === true || !utilityService.hasModuleAccess('PROPERTY')">
                                {{requestDetails.property?.property_name}}</p>
                            <p class="mt-1 truncate">
                                <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                    [routerLink]="utilityService.getLink('PROPERTY', requestDetails.property.property_uid)"
                                    *ngIf="!requestDetails.property?.is_deleted && utilityService.hasModuleAccess('PROPERTY')">
                                    {{requestDetails.property?.property_name}}</a>
                            </p>
                        </div>
                        <div *ngIf="requestDetails.request_priority"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer request-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500 mb-1">
                                {{'text.request_priority' | translate}}</p>
                            <badge class="my-2" [options]="getTagBadgeOptions(requestDetails?.request_priority)"
                                [matTooltip]="requestDetails?.request_priority" [matTooltipPosition]="'below'"></badge>
                        </div>
                        <div *ngIf="requestDetails.due_date"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer request-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'due.date.text' | translate}}</p>
                            <p class="mt-1 text-gray-900">
                                {{requestDetails.due_date | dateformat}}</p>
                        </div>
                        <div *ngIf="requestDetails?.request_preferred_date1?.start_time && requestDetails?.request_preferred_date1?.end_time"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer request-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'request.preferred_date1' | translate}}</p>
                            <p class="mt-1 text-gray-900 truncate">
                                <span>{{requestDetails?.request_preferred_date1?.start_time | dateformat}}</span>
                                <span class="ml-1">
                                    {{requestDetails?.request_preferred_date1?.start_time | timeformat}} - {{requestDetails?.request_preferred_date1?.end_time | timeformat}}
                                </span>
                            </p>
                        </div>
                        <div *ngIf="requestDetails?.request_preferred_date2?.start_time && requestDetails?.request_preferred_date2?.end_time"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer request-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'request.preferred_date2' | translate}}</p>
                            <p class="mt-1 text-gray-900 truncate">
                                <span>{{requestDetails?.request_preferred_date2?.start_time | dateformat}}</span>
                                <span class="ml-1">
                                    {{requestDetails?.request_preferred_date2?.start_time | timeformat}} - {{requestDetails?.request_preferred_date2?.end_time | timeformat}}
                                </span>
                            </p>
                        </div>
                        <div *ngIf="requestDetails.created_at"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer request-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'created_on.text' | translate}}</p>
                            <p class="mt-1 text-gray-900">
                                {{requestDetails.created_at | datetime}}</p>
                        </div>
                        <div *ngIf="requestDetails.created_by?.first_name"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer request-details-fields dark:bg-hover">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'created.by.text' | translate}}</p>
                            <p class="mt-1 text-gray-900 truncate">
                                {{requestDetails.created_by?.first_name}} {{requestDetails.created_by?.last_name ?? ''}}</p>
                        </div>
                    </div>
                </div>
                <div class="px-2 py-2 border-t text-base"
                    *ngIf="requestDetails.service_address && (requestDetails.service_address.street || requestDetails.service_address.state)">
                    <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                        {{'text.service_address' | translate}} </p>
                    <div class="px-3">
                        <p *ngIf="requestDetails.service_address.street" class="text-base mb-2">
                            {{requestDetails.service_address.street}}</p>
                        <p *ngIf="requestDetails.service_address.landmark" class="text-base mb-2">
                            {{requestDetails.service_address.landmark}}</p>
                        <p *ngIf="requestDetails.service_address.city" class="text-base mb-2">
                            {{requestDetails.service_address.city}}</p>
                        <p *ngIf="requestDetails.service_address.state" class="text-base mb-2">
                            {{requestDetails.service_address.state}}
                            {{requestDetails.service_address.zip_code ? '- ' +
                            requestDetails.service_address.zip_code : '' }}</p>
                        <p *ngIf="requestDetails.service_address.country" class="text-base">
                            {{requestDetails.service_address.country}}</p>
                    </div>
                </div>
                <div class="px-2 py-2 border-t text-base"
                    *ngIf="requestDetails.billing_address && (requestDetails.billing_address.street || requestDetails.billing_address.state)">
                    <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                        {{'billing.address.text' | translate}} </p>
                    <div class="px-3">
                        <p *ngIf="requestDetails.billing_address.street" class="text-base mb-2">
                            {{requestDetails.billing_address.street}}</p>
                        <p *ngIf="requestDetails.billing_address.landmark" class="text-base mb-2">
                            {{requestDetails.billing_address.landmark}}</p>
                        <p *ngIf="requestDetails.billing_address.city" class="text-base mb-2">
                            {{requestDetails.billing_address.city}}</p>
                        <p *ngIf="requestDetails.billing_address.state" class="text-base mb-2">
                            {{requestDetails.billing_address.state}}
                            {{requestDetails.billing_address.zip_code ? '- ' +
                            requestDetails.billing_address.zip_code : '' }}</p>
                        <p *ngIf="requestDetails.billing_address.country" class="text-base">
                            {{requestDetails.billing_address.country}}</p>
                    </div>
                </div>
            </div>
        </div>
    </li>
</ul>
<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!requests.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_parts_found.svg" alt="No Requests Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'requests.not_found.keyword' |
            translate}} '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'requests.not_found' |
            translate}}
        </h4>
    </div>
</div>